module.exports = __webpack_public_path__ + "img/trynano_full.a0261452.png";